import React from "react";
import {
  StyledCmSheetFooterContent,
  StyledCmSheetFooterContainer,
} from "./CmSheetFooter.styled";
import { CmSheetFooterLeft } from "../CmSheetFooterLeft/CmSheetFooterLeft";
import {
  CmSheetStateMachine,
  CollaboratorCmSheet,
} from "../../../../../../types/api/collaborators.type";
import { CmSheetFooterRight } from "../CmSheetFooterRight/CmSheetFooterRight";

interface CmSheetFooterProps {
  showEdit: boolean;
  showFooter: boolean;
  cmSheetInfo: CollaboratorCmSheet;
  cmSheetStateMachineInfo: CmSheetStateMachine;
  isInterim: boolean;
  disabledEditButton?: boolean;
  form?: string;
  onClick?: () => void;
  edit?: boolean;
  setEdit?: (value: boolean) => void;
  isMyProfile?: boolean;
}

export const CmSheetFooter = ({
  disabledEditButton,
  showEdit,
  showFooter,
  form,
  onClick,
  edit = false,
  setEdit,
  cmSheetInfo,
  cmSheetStateMachineInfo,
  isMyProfile,
  isInterim,
}: CmSheetFooterProps) => {
  return showFooter ? (
    <StyledCmSheetFooterContainer>
      <StyledCmSheetFooterContent>
        <CmSheetFooterLeft
          cmSheetInfo={cmSheetInfo}
          cmSheetStateMachineInfo={cmSheetStateMachineInfo}
          isMyProfile={isMyProfile}
          isInterim={isInterim}
        />
        <CmSheetFooterRight
          showEdit={showEdit}
          cmSheetInfo={cmSheetInfo}
          cmSheetStateMachineInfo={cmSheetStateMachineInfo}
          isMyProfile={isMyProfile}
          disabledEditButton={disabledEditButton}
          form={form}
          onClick={onClick}
          edit={edit}
          setEdit={setEdit}
        />
      </StyledCmSheetFooterContent>
    </StyledCmSheetFooterContainer>
  ) : null;
};
